import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { containersService } from '../../services';
import { i18n } from '../../i18n';
import { useIsSmallScreen } from '../../hooks';

interface ShareImagesModalType {
  images: { url: string }[];
  containerNumber: string;
  open: () => void;
}

export const shareImagesModal: ShareImagesModalType = {
  images: [],
  containerNumber: '',
  open: () => null,
};

export const ShareImagesModal = () => {
  const [open, setOpen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const isSmallScreen = useIsSmallScreen();

  useEffect(() => {
    shareImagesModal.open = () => {
      if (shareImagesModal.images.length <= 10) {
        containersService.shareImages(shareImagesModal.images, shareImagesModal.containerNumber);
        return;
      }

      setStartIndex(0);
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    setOpen(!open);
  };

  const handleSubmitClick = () => {
    const endIndex = startIndex + 10;
    setStartIndex(endIndex);

    containersService.shareImages(
      shareImagesModal.images.slice(startIndex, endIndex),
      shareImagesModal.containerNumber,
    );

    if (endIndex >= shareImagesModal.images.length) {
      setOpen(false);
    }
  };

  return (
    <ModalBase
      id={'share-images-modal'}
      paperSize={isSmallScreen ? 'mobile' : 'default'}
      open={open}
      onClose={handleOnClose}
    >
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {shareImagesModal.containerNumber} - {i18n.t('pages.modal.shareImagesTitle')}:{' '}
          {shareImagesModal.images.length}
        </Typography>
        {isSmallScreen && <span />}
        <ModalFooterButtons>
          <Button size={'medium'} onClick={handleSubmitClick}>
            {i18n.t('pages.modal.shareImagesTitle')} {startIndex + 1} -{' '}
            {startIndex + 10 >= shareImagesModal.images.length
              ? shareImagesModal.images.length
              : startIndex + 10}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
